import { useCallback } from 'react'
import { useMarket } from '../contexts/MarketContext'
import { VARIANT_ID } from '../data/markets'
import { trackAddToCart } from '../utils/metaPixel'

const PRODUCT_NAME = 'El Gran Reto Creativo'

/**
 * Click handler shared by every purchase CTA: reports the Meta AddToCart event
 * with the exact amount and currency the visitor is seeing.
 *
 * It NEVER calls preventDefault and never throws: any tracking failure is
 * swallowed so the browser always completes the normal navigation to the
 * Shopify cart.
 */
export function useAddToCart(): () => void {
  const { market } = useMarket()

  return useCallback(() => {
    try {
      trackAddToCart({
        value: market.priceAmount,
        currency: market.currency,
        contentId: VARIANT_ID,
        contentName: PRODUCT_NAME,
      })
    } catch {
      /* tracking must never block the purchase */
    }
  }, [market.priceAmount, market.currency])
}
